import React, { useEffect, useRef, useState } from 'react';

interface LinkInputPanelProps {
  initial?: string;
  placeholder?: string;
  onSubmit: (value: string) => void;
  onClose: () => void;
}

export const LinkInputPanel: React.FC<LinkInputPanelProps> = ({ initial = '', placeholder = 'Add link and hit enter', onSubmit, onClose }) => {
  const [value, setValue] = useState(initial);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
    try { inputRef.current?.select(); } catch {}
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const v = value.trim();
      if (v.length > 0) onSubmit(v);
      onClose();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      onClose();
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg border border-[#E5E7EB] p-2 min-w-[320px]">
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className="w-full px-3 py-2 rounded-md border border-[#CBD5E1] outline-none focus:ring-2 focus:ring-blue-500 text-sm"
      />
    </div>
  );
};

